/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Cash_NetInputs */

const vi_dashboard_manager_cash_net = /** @type {(inputs: Dashboard_Manager_Cash_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ròng`)
};

/**

* @param {Dashboard_Manager_Cash_NetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_cash_net = /** @type {((inputs?: Dashboard_Manager_Cash_NetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Cash_NetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_cash_net(inputs)
});